module.exports = __webpack_public_path__ + "static/media/1163.7c2b94a9.jpg";